import { object, string, optional, record, unknown } from 'superstruct';

export const assetConfigConfigSchema = object({
  overrides: optional(record(string(), unknown())),
});
